<template>
  <div id="app">
    <keep-alive>
      <router-view v-wechat-title="$route.meta.title" v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <router-view  v-wechat-title="$route.meta.title" v-if="!$route.meta.keepAlive">
    </router-view>
    <common-bottom v-if="isPcRouteName"></common-bottom>
  </div>
</template>

<script>
import { isMobile } from "@/assets/js/location";
import CommonBottom from "@/components/CommonBottom";
export default {
  name: "App",
  components: {
    CommonBottom,
  },
  mounted() {
    this.changeUrl();
  },
  methods: {
    changeUrl() {
      if (!!this.$route.name) {
        if (isMobile() && this.isPcRouteName) {
          this.$router.replace({
            name: "wap-" + this.$route.name,
            query: this.$route.query,
          });
        } else if (!isMobile() && !this.isPcRouteName) {
          this.$router.replace({
            name: this.$route.name.slice(4),
            query: this.$route.query,
          });
        } else {
        }
      }
    },
  },
  watch: {
    $route(to) {
      this.changeUrl();
    },
  },
  computed: {
    isPcRouteName: function () {
      if (!!this.$route.name && this.$route.name.indexOf("wap-") == -1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
@import url("./assets/css/reset.css");
@import url("./assets/css/common.css");
@import url("./assets/css/animate.css");
</style>


// WEBPACK FOOTER //
// src/App.vue